import {
  Collapse as CollapseAntd,
  Table as TableAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const TableTmovShipper = styled(TableAntd)`
  .ant-table,
  .ant-table-thead > tr > th {
    color: #000000;
  }

  .ant-table table {
    table-layout: fixed !important;
  }

  .ant-table-thead > tr > th {
    background: #ffffff;
    border: 1px solid #ffffff;
    color: #000000;
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 22px;
    padding: 0px 0px !important;

    &.center {
      text-align: center !important;
    }
  }

  .ant-table-tbody > tr > td {
    padding: 1px 1px;
    border: 1px solid #ffffff;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 22px;
  }
`;

export const Title = styled.span`
  display: block;

  &.center {
    text-align: center !important;
  }
`;

// TARIFA CLIENTE TMOV
export const TextMin = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
`;

export const Collapse = styled(CollapseAntd)`
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;

  .ant-collapse-arrow {
    left: auto;
  }

  .ant-collapse-header {
    font-family: Roboto;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px !important;
    color: #000000 !important;
    background: rgba(250, 250, 250, 1);
  }

  /* .ant-collapse-header {
    font-family: Roboto !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    color: #000000 !important;
    font-weight: bold !important;
  } */
`;
